import React, { ReactElement, useState, useEffect,useRef } from "react";
import { Modal, notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { EditableList } from "../../../../compnents/list/EditableList";
import { pitestQueryParams } from "../../../../services/nopitest";
import {
  getPitestList,
  pitestDetail,
  selectCurrent,
  selectNopitestData,
  selectPageLoading,
  selectTotal,
  setCurrent,
  setPageLoading,
  pitestInvalidate,
} from "./nopitestSlice";
import { Columns } from "./columns";
import { NoPitestQuery } from "./Query";
import { PitestModal } from "./Modal";
import { RegisterModal } from "./registerModal";
import styles from "./nopitest.module.css";
import { RootDispatch } from "../../../../app/store";
import { unwrapResult } from "@reduxjs/toolkit";
import { ExclamationCircleFilled } from "@ant-design/icons";
export const NoPitest = (
  props:{
    value ?:any,
  }
  
): ReactElement => {
  const dispatch = useDispatch<RootDispatch>();

  const [SelectId, setSelectId] = useState(0);

  const Current = useSelector(selectCurrent);

  const total = useSelector(selectTotal);

  const data = useSelector(selectNopitestData);

  const [size, setSize] = useState(10);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [isModalRegisterVisible, setIsModalRegisterVisible] = useState(false);

  const [queries, setQueries] = useState<pitestQueryParams>();

  const pageLoadingRX = useSelector(selectPageLoading);

  const [invalidateVisible, setInvalidateVisible] = useState(false)
  
  const [modalBtnLoading, setModalBtnLoading] = useState(false)

  const [invalidateId, setInvalidateId] = useState('')

  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (props.value == 0) {
      if (queries?.timeHead) {
        dispatch(setPageLoading(true))
        dispatch(getPitestList({ ...queries, current: Current, size }));
        setTimeout(() => {
          dispatch(setPageLoading(false))
        }, 3000)
      }
    }
  }, [props.value,queries, size, Current])
  
  interface ProgressItem {
    id: number; // 使用item的id
    percent: number;
    startTime: string;
    presetTime: string;
    totalSeconds: number;
    elapsedSeconds: number;
  }

  const [currentProgress, setCurrentProgress] = useState<ProgressItem[]>([]);

  useEffect(() => {
    console.log("重新计算...");
    // 清除之前的定时器
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }

    const psIngData = data?.filter((v: any) => v.state == 1);
    if (!psIngData || psIngData.length <= 0) {
      console.log("没有可渲染的数据");
      setCurrentProgress([]);
      return;
    }

    console.log("当前data:", psIngData);

    // 1. 计算每个皮试项的初始进度
    const initialProgress: ProgressItem[] = psIngData.map((item: any) => {
      // 解析开始时间
      const startTime = new Date(item.startTime).getTime();
      const currentTime = new Date().getTime();
      const presetMinutes = parseInt(item.presetTime) || 1;
      const totalSeconds = presetMinutes * 60;

      // 计算已过去的时间（秒）
      const elapsedSeconds = (currentTime - startTime) / 1000;

      // 计算初始进度百分比（0-100），保留1位小数
      let percent = (elapsedSeconds / totalSeconds) * 100;

      // 确保百分比在合理范围内
      percent = Math.max(0, Math.min(100, percent));

      return {
        id: item.id, // 使用item的id而不是索引
        percent: Number(percent.toFixed(1)), // 保留1位小数
        startTime: item.startTime,
        presetTime: item.presetTime,
        totalSeconds: totalSeconds,
        elapsedSeconds: elapsedSeconds
      };
    });

    // 设置初始进度
    setCurrentProgress(initialProgress);

    // 2. 进度更新函数 - 基于实际时间计算
    const updateProgress = (progress: ProgressItem[]): ProgressItem[] => {
      const currentTime = new Date().getTime();

      return progress.map(item => {
        // 如果进度已完成，保持100%
        if (item.percent >= 100) {
          return {
            ...item,
            percent: 100,
            elapsedSeconds: item.totalSeconds
          };
        }

        // 基于实际时间计算进度
        const startTime = new Date(item.startTime).getTime();
        const elapsedMilliseconds = currentTime - startTime;
        const elapsedSeconds = elapsedMilliseconds / 1000;

        // 计算新的百分比，保留1位小数
        const percent = Math.min(100, (elapsedSeconds / item.totalSeconds) * 100);

        return {
          ...item,
          percent: Number(percent.toFixed(1)), // 保留1位小数
          elapsedSeconds: elapsedSeconds
        };
      });
    };

    // 3. 启动定时器
    timerRef.current = setInterval(() => {
      setCurrentProgress(prev => {
        const updated = updateProgress(prev);

        // 检查是否所有进度都已完成
        const allCompleted = updated.every(item => item.percent >= 100);

        if (allCompleted && timerRef.current) {
          clearInterval(timerRef.current);
          timerRef.current = null;
          console.log("所有进度已完成");
        }

        console.log("更新进度:", JSON.stringify(updated));
        return updated;
      });
    }, 1000);

    // 清理函数
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [data]);
  useEffect(() => {
    console.log("kkkk",JSON.stringify(currentProgress))

  }, [currentProgress]);
  return (
    <>
      <div className={styles.content}>
        <NoPitestQuery
          loading={pageLoadingRX}
          onValueChange={(v) => {
            setQueries({ ...queries, ...v });
            dispatch(setCurrent(1));
          }}
        />
        <EditableList
          rowKey={(_, i) => `${i}}`}
          loading={pageLoadingRX}
          className={styles.nopitest}
          page={{
            items: data,
            current: Current,
            size: size,
            total: total,
          }}
          onChangePage={(current, pageSize) => {
            setSize(pageSize as number);
            dispatch(setCurrent(current));
          }}
          columns={Columns((id, text) => {
            if (text == "开始皮试") {
              setIsModalVisible(true);
              dispatch(pitestDetail(id));
            } else if (text == "作废") {
              setInvalidateVisible(true);
              setInvalidateId(id);
            } else {
              setIsModalRegisterVisible(true);
              dispatch(pitestDetail(id));
            }
          }, size * (Current - 1),currentProgress)}
        />
      </div>
      <PitestModal
        isModalVisible={isModalVisible}
        queries={queries}
        onOk={() => {
          setIsModalVisible(false);
        }}
        onCancel={() => {
          setIsModalVisible(false);
          dispatch(getPitestList({ ...queries, current: Current, size }));
        }}
      />
      <RegisterModal
        isModalRegisterVisible={isModalRegisterVisible}
        queries={queries}
        onOk={() => {
          setIsModalRegisterVisible(false);
          // setSelectId(0)
        }}
        onCancel={() => {
          setIsModalRegisterVisible(false);
          dispatch(getPitestList({ ...queries, current: Current, size }));
          // setSelectId(0)
        }}
      />
      <Modal
        title={"确认操作"}
        width={400}
        visible={invalidateVisible}
        confirmLoading={modalBtnLoading}
        onOk={() => {
          setModalBtnLoading(true)
          dispatch(pitestInvalidate(invalidateId))
            .then(unwrapResult)
            .then(() => {
              notification.success({
                message: "操作成功",
                duration: 3,
              })
              setModalBtnLoading(false)
              setInvalidateVisible(false)
              dispatch(setPageLoading(true))
              dispatch(getPitestList({ ...queries, current: Current, size }))
              setTimeout(() => {
                dispatch(setPageLoading(false))
              }, 3000)
            })
        }}
        onCancel={() => setInvalidateVisible(false)}
      >
        <div style={{ display: "flex", lineHeight: "22px" }}>
          <div style={{ color: '#ffae55', fontSize: 24, marginRight: 10 }}>
            <ExclamationCircleFilled />
          </div>
          <p>确认作废？</p>
        </div>
      </Modal>
    </>
  );
};
